import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { ArrowLeftRight, PlusCircle, ThreeDotsVertical } from 'react-bootstrap-icons';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import FormSelect from '../../../../Components/FormTag/FormSelect';
import InputFiled from '../../../../Components/FormTag/InputFiled';
import OffCanvas from '../../../../Components/FormTag/OffCanvas';
import Table, { Column } from '../../../../Components/Tables/Table';
import { asnDate, eta } from '../../../../Data/dropdownDataList';
import { inboundReturnReceiveInProgressData, inboundReturnsReceiveCompletedData, inboundReturnsReceiveList } from '../../../../Data/testData';
import PageHeader from '../../../../Layout/PageHeader';
import { ALPHANUM_SPACE_REGEX } from '../../../../Shared/Helper/Constant';
import { PATTERN_ERR_MSG } from '../../../../Shared/Helper/ValidationMessage';
import Tabs from '../../../../Shared/Tab/Tab';
import { asnAdvanceFilter } from '../CheckIn/CheckIn.type';
import ImportLayout from "../../../../Layout/ImportLayout";
import ExportLayout from "../../../../Layout/ExportLayout";
import CommonModal from '../../../../Components/Modals/CommonModal';

export default function ReturnReceiveOverview() {
    const pageName = "Receive";
    const [isShowCanvas, setShowCanvas] = useState(false);
    const navigation = useNavigate();
    const [showModalForImportAndExport, setShowModalForImportAndExport] =
    useState({
      importModal: false,
      exportModal: false,
    });
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handleShow = () => setShow(!show);
    const [isAddButtonDisable, setAddButtonDisable] = useState(false);
    const [asnAdvanceFilterData, setAsnAdvanceFilterData] =
      useState<asnAdvanceFilter>(new asnAdvanceFilter());
    const {
      handleSubmit,
      register,
      reset,
      setValue,
      control,
      formState: { errors },
    } = useForm<asnAdvanceFilter>({
      defaultValues: asnAdvanceFilterData,
    });
    const nextData: SubmitHandler<asnAdvanceFilter> = (data) => {
      setAsnAdvanceFilterData(data);
      handleGlobalFilter();
    };
    const handleGlobalFilter = () => {
    //  setShowCanvas(!isShowCanvas);
    };
    const handleGlobalSearch = () => {
      // setShowCanvas(!isShowCanvas);
     };
    const headerChildren = (
      <>
        <div className="d-flex align-items-center gap-1">
          <Dropdown>
            <Dropdown.Toggle
              className="btn bg-white text-dark dropdown-toggle"
              id="dropdown-basic"
            >
              Saved Filter
            </Dropdown.Toggle>
  
            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
                One line count
              </Dropdown.Item>
              <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
                Special count
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>
    );
  
    const columns: Column[] = [
      {
        name: "Return #",
      selector: (row: { ASN: string }) => (
          <span className="cursor-pointer text-primary">
              {row.ASN}
          </span>
      ),
      },
      {
        name: "Supplier ",
        selector: (row: { Supplier: string }) => row.Supplier,
      },
      {
        name: "Tracking",
        selector: (row: { Tracking: string }) => row.Tracking,
      },
      {
        name: "Door",
        selector: (row: { Door: string }) => row.Door,
      },
      {
        name: "ATA",
        selector: (row: { ATA: string }) => row.ATA,
      },
      {
        name: "Status",
        selector: (row: { Status: string }) => {
          return row.Status === "New" ? (
            <span className="badge asn-overview-status asn-overview-status-border-blue">
              Ready to Receive
            </span>
          ) : row.Status === "Backorder" ? (
            <span className="badge text asn-overview-status asn-overview-status-border-red">
              Backorder
            </span>
          ) : row.Status === "Completed" ? (
            <span className="badge asn-overview-status asn-overview-status-border-green">
              Receive Complete
            </span>
          ) : row.Status === "Ready to Check-in" ? (
            <span className="badge asn-overview-status asn-overview-status-border-red">
              Receive on Progress
            </span>
          ) : row.Status === "Ready to Unload" ? (
            <span className="badge asn-overview-status asn-overview-status-border-blue">
              Ready to Unload
            </span>
          ) : row.Status === "Ready to Receive" ? (
            <span className="badge asn-overview-status asn-overview-status-border-blue">
              Ready to Receive
            </span>
          ) : row.Status === "Ready to Putaway" ? (
            <span className="badge asn-overview-status asn-overview-status-border-blue">
              Ready to Putaway
            </span>
          ) : (
            <></>
          );
        },
      },
      {
        name: (
          <>
            <ArrowLeftRight /> <PlusCircle />
          </>
        ),
        selector: (row: any) => (
          <>
            <span
              className="cursor-pointer dropdown-toggle action-menu border-none"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <ThreeDotsVertical />
            </span>
            <ul className="dropdown-menu action-items">
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelEditAction(row)}
              >
                Edit
              </li>
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelInactiveAction(row)}
              >
                Inactive
              </li>
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={handelDeleteAction}
              >
                Delete
              </li>
            </ul>
          </>
        ),
      },
    ];
    const handelEditAction = (data: any) => {};
    const handelInactiveAction = (data: any) => {};
    const handelDeleteAction = (data: any) => {};
  
    const handleRowClick = (data: any) => {
      navigation(`/inbound/returns/receive/details/${data.ASN}`);
    };
    const handelSelectRows = (selectedRow: Set<number>) => {
      setAddButtonDisable(selectedRow.size > 0);
    };
    const onCurrentPageChange = (page: number) => {
      // Handle page change here if needed
      console.log('Page changed to:', page);
    };
    const tabs = [
      {
        order: 0,
        label: "Ready to Receive | " + inboundReturnsReceiveList.length,
        content: (
          <Table
          customClassName="sph-table-color"
            columns={columns}
            data={inboundReturnsReceiveList}
             pagination={{
          recordsPerPage: 15,
          totalRecords: inboundReturnsReceiveList.length,
          onCurrentPageChange: onCurrentPageChange
        }}
            handleRowClick={handleRowClick}
            onSelectedRowsChange={handelSelectRows}
          />
        ),
        visibility: true,
        status: true,
      },
      {
        order: 1,
        label: "Receive In Progress| " + inboundReturnReceiveInProgressData.length,
        content: (
          <Table
          customClassName="sph-table-color"
            columns={columns}
            data={inboundReturnReceiveInProgressData}
             pagination={{
          recordsPerPage: 15,
          totalRecords: inboundReturnReceiveInProgressData.length,
          onCurrentPageChange: onCurrentPageChange
        }}
            handleRowClick={handleRowClick}
            // onSelectedRowsChange={handelSelectRows}
          />
        ),
        visibility: true,
        status: false,
      },
      {
        order: 2,
        label: "Receive Completed | " + inboundReturnsReceiveCompletedData.length,
        content: (
          <Table
          customClassName="sph-table-color"
            columns={columns}
            data={inboundReturnsReceiveCompletedData}
             pagination={{
          recordsPerPage: 15,
          totalRecords: inboundReturnsReceiveCompletedData.length,
          onCurrentPageChange: onCurrentPageChange
        }}
            handleRowClick={handleRowClick}
            // onSelectedRowsChange={handelSelectRows}
          />
        ),
        visibility: true,
        status: true,
      },
    ];
  return (
    <>
    <PageHeader
      addUrl="/inbound/returns/receive/add"
      listUrl="/inbound/returns/receive"
      name={pageName}
       handleGlobalFilter={handleGlobalFilter}
       handleGlobalSearch={handleGlobalSearch}
      nameButtonStatus={isAddButtonDisable}
      setShowModalForImportAndExport={setShowModalForImportAndExport}
      showModalForImportAndExport={showModalForImportAndExport}
    />

    <div className="clearfix"></div>

    <h5 className="text-start mt-1 mb-3">{pageName}</h5>

    <div>
      <Tabs tabs={tabs} isCheckbox={true} />
    </div>
    <div className="inbound-CheckIn-Table-Main-Div"></div>
    <OffCanvas
      show={isShowCanvas}
      handleClose={handleGlobalFilter}
      title="Advance Filter"
      headerChildren={headerChildren}
    >
      <>
        <div className="offcanvas-body offcanvas-height custom-scrollbar">
          <form>
            <div className="">
              <div>
                <label>ASN Date</label>
                <div>
                  <FormSelect
                    tabIndex={1}
                    name="asnDate"
                    control={control}
                    optionList={asnDate}
                    className="form-control p-0"
                    placeholder="Select"
                    isSearchable={true}
                  />
                </div>
              </div>
              <div className="my-3">
                <label>Supplier</label>
                <div>
                  <InputFiled
                    tabIndex={2}
                    type="text"
                    register={register}
                    name="supplier"
                    errors={errors.supplier}
                    className="form-control"
                    placeholder="Enter supplier"
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                  />
                </div>
              </div>
              <div>
                <label>ETA</label>
                <div>
                  <FormSelect
                    tabIndex={1}
                    name="eta"
                    control={control}
                    optionList={eta}
                    className="form-control p-0"
                    placeholder="Select"
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="offcanvs-footer d-flex justify-content-end  px-0 border-top pt-3">
          <button
            className="btn offcanvas-close-btn px-4 mx-2 "
            onClick={handleGlobalFilter}
          >
            Clear
          </button>
          <button
            className="btn offcanvas-apply-btn px-4 px-2 "
            onClick={handleSubmit(nextData)}
          >
            Apply
          </button>
        </div>
      </>
    </OffCanvas>
    <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
  </>
  )
}
